//@ts-check
import { curatorApiClient } from '../../utils/RequestClient';

/**
 * @param {object} params
 * @param {AbortSignal} [params.signal]
 * @returns {Promise<import('@action-types/industries').IndustriesResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/common').CuratorApiErrorResponse>}
 */
const getIndustries = async ({ signal }) => {
  const { jsonResponse } = await curatorApiClient.fetch({
    endpoint: `/get-industries`,
    requestOptions: {
      signal,
      headers: {
        accept: 'application/json',
      },
    },
  });
  return jsonResponse;
};

export default getIndustries;
